import formatDaterange from "../../../../../gd/format/daterange";


export default class ReportProjectTimeReportByUser_Settings {

    public projectId        : ID | null
    public daterange        : DateRange
    public users            : ID[]
    public hideEmptyTasks   : boolean
    public estimate         : boolean
    public timeReported     : boolean
    public spentEstimate    : boolean

    constructor(data: any) {
        this.daterange        = _.get(data, "daterange", null)
        this.projectId        = _.get(data, "projectId", null)
        this.users            = _.get(data, "users", [])
        this.hideEmptyTasks   = _.get(data, "hideEmptyTasks", true)
        this.estimate         = _.get(data, "estimate", false)
        this.timeReported     = _.get(data, "timeReported", false)
        this.spentEstimate    = _.get(data, "spentEstimate", false)
    }

    get reportTitle() {
        return formatDaterange(this.daterange)
    }

    toJSON(): JSONObject {
        const result: JSONObject = {
            projectId        : this.projectId,
            users            : this.users,
            hideEmptyTasks   : this.hideEmptyTasks,
            estimate         : this.estimate,
            timeReported     : this.timeReported,
            spentEstimate    : this.spentEstimate
        }

        if (this.daterange) {
            result['daterange'] = {
                start   : this.daterange.start.format("YYYY-MM-DD"),
                end     : this.daterange.end.format("YYYY-MM-DD")
            }
        }

        return result
    }
}
